import styled from 'styled-components';
import { colors, Grid, Row } from '@dexma/ui-components';

export const StyledConfigFlexContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .ant-tabs-nav {
        width: 100%;
    }
    .ant-tabs-tab {
        display: block;
        flex: 1;
        text-align: center;
    }

    .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {
        display: unset;
        width: 100%;
    }

    .ant-tabs-nav div:first-of-type {
        place-content: center;
    }

    .ant-tabs-content {
        height: 100%;
        overflow-x: hidden;
    }

    .ant-tabs-nav div:first-of-type {
        place-content: center;
    }
`;

export const StyledRowWidgetType = styled(Row)`
    align-items: start;
    margin-top: 12px;
    margin-bottom: 12px;
`;

export const StyledConfigFieldGroup = styled(Grid)`
    padding: 4px 32px 0px 32px;
    flex: none;

    height: 64px;
    .title {
        color: ${colors.gray500};
        font-size: 16px;
    }
    .widget-type-block {
        margin-top: 12px;
    }
`;

export const StyledConfigFlexScrollContent = styled.div`
    flex: 1 1 auto;
    overflow: hidden;
    .ant-tabs-nav-more {
        display: none;
    }
`;

export const StyledConfigFooter = styled.div`
    width: 100%;
    flex: none;
    padding: 16px 0;
    margin-left: 24px;
`;
